<template>
  <vx-card no-shadow class="user-settings-general-component">
    <!-- Img Row -->
    <div class="flex flex-wrap items-center mb-base">
      <vs-avatar
        :src="activeUserInfo.image"
        size="70px"
        class="mr-4 mb-4"
      />
      <div>
        <vs-button
          class="mr-4 sm:mb-0 mb-2"
          @click.prevent="popupActive = true"
        >
          Atualizar Foto
        </vs-button>
        <p class="text-sm mt-2">
          Permitido JPG, GIF ou PNG. Tamanho máximo de 800kB
        </p>
      </div>
    </div>

    <vs-popup
      class="user-settings-upload-image-popup"
      title="Atualizar Imagem"
      :active.sync="popupActive"
    >
      <upload
        :action="uploadApiUrl"
        fileName="file"
        :headers="{
          Authorization: 'Bearer ' + bearer
        }"
        text="Escolher Imagem"
        automatic
        :limit="1"
        :single-upload="true"
        @on-success="successUpload"
        @on-error="errorUpload"
      />

      <div class="flex flex-wrap items-center justify-center">
        <vs-button
          class="mr-4 sm:mb-0 mb-2"
          type="filled"
          color="rgb(62, 201, 214)"
          @click.prevent="updateProfilePicture"
        >
          Salvar
        </vs-button>
      </div>
    </vs-popup>

    <!-- Info -->
    <vs-input class="w-full mb-base" label-placeholder="Nome" v-model="activeUserInfo.name"/>
    <vs-input class="w-full mb-base" label-placeholder="Email" v-model="activeUserInfo.email"/>
    <div v-if="activeUserInfo.role.id === 2">
      <vs-input class="w-full mb-base" label-placeholder="Facebook - Link para o seu perfil" v-model="activeUserInfo.social_networks.facebook"/>
      <vs-input class="w-full mb-base" label-placeholder="Twitter - Link para o seu perfil" v-model="activeUserInfo.social_networks.twitter"/>
      <vs-input class="w-full mb-base" label-placeholder="Instagram - Link para o seu perfil" v-model="activeUserInfo.social_networks.instagram"/>
    </div>

    <!-- Save & Reset Button -->
    <div class="flex flex-wrap items-center justify-end">
      <vs-button
        @click.prevent="updateUser"
        class="ml-auto mt-2"
        type="filled"
        color="rgb(62, 201, 214)"
      >
        Salvar
      </vs-button>
    </div>
  </vx-card>
</template>

<script>
  import Upload from '@/components/upload/Upload'

  export default {
    components: {
      Upload
    },
    data() {
      return {
        popupActive: false,
        newImageUrl: null,
        activeUserInfo: {
          id: null,
          name: '',
          email: '',
          password: '',
          role: {
            id: '',
            name: ''
          },
          social_networks: {
            facebook: '',
            twitter: '',
            instagram: ''
          }
        }
      }
    },
    computed: {
      uploadApiUrl() {
        return process.env.VUE_APP_API_BASE_URL + 'api/file/upload'
      },
      bearer() {
        return this.$store.state.auth.bearer
      }
    },
    methods: {
      updateProfilePicture() {
        this.activeUserInfo.image = this.newImageUrl
        this.updateUser()
        this.popupActive = {}
      },
      errorUpload(request) {
        console.log(request)
      },
      successUpload(response) {
        this.$vs.notify({
          color: 'success',
          title: 'Imagem carregada com sucesso',
          text: response.data.message
        })

        this.newImageUrl = response.data.fileUrl
      },
      updateUser() {
        this.$store.dispatch("user/update", this.activeUserInfo).then(response => {
          this.$store.dispatch('updateUserInfo', response.data.data.updateUser.user)
        }).catch(err => {
          console.error(err)
        })
      }
    },
    mounted() {
      this.activeUserInfo = this.$_.cloneDeep(this.$store.state.AppActiveUser)
    }
  }
</script>

<style lang="scss">
  .user-settings-upload-image-popup {
    .con-img-upload {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
</style>
